import React, { useState, useImperativeHandle, forwardRef, useEffect } from 'react';
import HelpCard from '../HelpCard';
import { useSelector, useDispatch } from 'react-redux';
import { filterVoucherTypeData, numberSeriesList, serialNumberList } from '../../../redux/actions/action-creator';
import { openModal } from '../../../redux/actions/action-creator';

const VoucherHelp = forwardRef((props, ref) => {
    const dispatch = useDispatch();
    const { voucher_type_data = null } = useSelector(state => state.common);
    useEffect(() => {
        const handleKeyDown = (e) => {
         if (e.key === 'F4') {
            e.preventDefault();
            props.displayNameOfVoucherType('Contra', voucher_type_data)
          } else if (e.key === 'F5') {
            e.preventDefault();
            props.displayNameOfVoucherType('Payment', voucher_type_data)
          } else if (e.key === 'F6') {
            e.preventDefault();
            props.displayNameOfVoucherType('Receipt', voucher_type_data)
          } else if (e.key === 'F7') {
            e.preventDefault();
            props.displayNameOfVoucherType('Journal', voucher_type_data)
          } else if (e.key === 'F8') {
            e.preventDefault();
            // setshow_account_list(false)
            props.displayNameOfVoucherType('Sales', voucher_type_data)
          } else if (e.key === 'F9') {
            e.preventDefault();
            props.displayNameOfVoucherType('Purchase', voucher_type_data)
          }
        }
        window.addEventListener('keydown', handleKeyDown);
        return () => {
          window.removeEventListener('keydown', handleKeyDown);
        };
      }, [
        props.displayNameOfVoucherType
      ]);

    const fields = [
        { id: "1", name: "Date", shortcutKey: "F2", state: () => dispatch(openModal('period')) },
        { id: "2", name: "Contra", shortcutKey: "F4", state: () => props.displayNameOfVoucherType('Contra', voucher_type_data) },
        { id: "3", name: "Payment", shortcutKey: "F5", state: () => props.displayNameOfVoucherType('Payment', voucher_type_data) },
        { id: "4", name: "Receipt", shortcutKey: "F6", state: () => props.displayNameOfVoucherType('Receipt', voucher_type_data) },
        { id: "5", name: "Journal", shortcutKey: "F7", state: () => props.displayNameOfVoucherType('Journal', voucher_type_data) },
        { id: "6", name: "Sales", shortcutKey: "F8", state: () => props.displayNameOfVoucherType('Sales', voucher_type_data) },
        { id: "7", name: "Purchase", shortcutKey: "F9", state: () => props.displayNameOfVoucherType('Purchase', voucher_type_data) },
        { id: "8", name: "Other Voucher", shortcutKey: "F10", state: () => dispatch(openModal('otherVoucher')) },
        { id: "9", name: "Change Mode", shortcutKey: "H", state: () => dispatch(openModal('changeMode')) },
        { id: "10", name: "Post Dated", shortcutKey: "L", state: () => dispatch(openModal('postDated')) },
    ]


    return (
        <>
            {
                fields.map((item, index) => {
                    return (
                        <HelpCard key={item.id} fields={item} />
                    )
                })
            }
            <div style={{ position: 'absolute', bottom: 0, width: '100%' }}>
                <div className='help_button_card mb-1 ms-1' >
                    <button className={`button_padding`} style={{ background: 'white', paddingTop: 3, paddingBottom: 3, marginBottom: 2 }}>
                        <p className='card-header'>
                            <span>F12</span>:
                            Configure
                        </p>
                    </button>
                </div>
            </div>

        </>
    )
})

export default VoucherHelp;
